"use client"

import { ProductCard } from "../ProductCard/ProductCard"
import { HttpTypes } from "@medusajs/types"
import { useScreenSize } from "@/hooks/useScreenSize"
import { useEffect, useState } from "react"
import { SkeletonProductCard } from "../ProductCard/SkeletonProductCard"
import { isBarebonesTheme } from "@/lib/theme/storefront-theme"
import { useStorefrontTheme } from "@/lib/theme/storefront-theme-context"

export const ProductsList = ({
  products,
  locale,
}: {
  products: HttpTypes.StoreProduct[]
  locale: string
}) => {
  const screenSize = useScreenSize()
  const theme = useStorefrontTheme()
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  if (!isClient) {
    return (
      <>
        {products.map((product) => (
          <SkeletonProductCard
            key={product.id}
          />
        ))}
      </>
    )
  }

  return (
    <div className={isBarebonesTheme(theme) ? "grid grid-cols-2 lg:grid-cols-4 gap-8" : "grid grid-cols-3 min-[1025px]:grid-cols-4 min-[1441px]:grid-cols-5 gap-[30px]"}>
      {products.map((product) => (
        <ProductCard
          key={product.id}
          product={product}
          api_product={product}
          locale={locale || ""}
        />
      ))}
    </div>
  )
}
